<template>
  <div class="break">
    <!-- <></> -->
    <p class="break__p">
      کیفیت باور نکردنی <br />
      تنوع محصولات
    </p>
    <!-- <p class="break__pp"></p> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true
    };
  }
};
</script>
<style lang="scss" scoped>
.break {
  margin-right: auto;
  margin-left: auto;
  width: 98%;
  height: 200px;
  margin-top: 1.5em;
  border-radius: 10px;
  box-shadow: 0 0 5px black;
  background-repeat: no-repeat;
  background-attachment: fixed;
  //   background-position: center right;
  background-size: cover; /* Resize the background image to cover the entire container */
  background-image: linear-gradient(
      to right top,
      #994b92,
      #ae458e,
      #c13f8479,
      #d339799a,
      #e1366c7a,
      #ea416391,
      #f04d58,
      #f55b50,
      #f86e4f,
      #fa8452,
      #fb9657,
      #fba85f
    ),
    url("../../../assets/photo/11.jpg");
  @media screen and (max-width: 500px) {
    height: 100px;
  }
  &__p {
    font-size: 4em;
    color: var(--main-color);
    font-family: "lalezar";
    width: 100%;
    height: 100%;
    // background: red;
    display: flex;
    justify-content: flex-end;
    padding-right: 1em;
    text-shadow: 0 0 5px var(--shrink);
    align-items: center;
    @media screen and (max-width: 900px) {
      font-size: 3em;
    }
    @media screen and (max-width: 800px) {
      font-size: 2.5em;
    }
    @media screen and (max-width: 500px) {
      font-size: 1em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/components/break1.vue